import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import App from './App';
import { tempoTheme } from '@/theme/tempoTheme';
import { applyCssVariables } from '@/theme/cssVars';
import '@/styles/global.css';

applyCssVariables();

// message.*, notification.* and Modal.confirm render outside the React tree; give them the theme too
ConfigProvider.config({
  holderRender: (children) => <ConfigProvider theme={tempoTheme}>{children}</ConfigProvider>,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider theme={tempoTheme}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
